import React from "react";
//import PropTypes from 'prop-types';

import { FormLayout } from "playground/cms/Form";
import { useApiActions, useData } from "state/hooks";
import { sendForm } from "cms/state/actions/forms";
import StatusIcon from "./StatusIcon";
import Button from "components/Button";
import { DateTime } from "../../../../components/DateDiff";

const statusDescriptions = {
    success: "Wysłano",
    pending: "Nie wysłano",
    failed: "Błąd wysyłki",
    failed_challenge: "Nieprawidłowa autoryzacja",
};

export function ResponseForm(props) {
    const { id } = props;
    const data = useData(props);
    const { onSend } = useApiActions({ onSend: sendForm });
    const recipients = data.recipients || [];
    const status = data.status_code;
    return (
        <FormLayout.Fieldset pad>
            <div className={"cols gap-sm cols-middle cols-spread"}>
                <div className={"cols gap-sm cols-middle"}>
                    <StatusIcon status={status} fontSize={"lg"} />
                    <div>
                        {statusDescriptions[status]}{" "}
                        {status === "success" && (
                            <span>
                                <DateTime value={data.sent_at} />
                            </span>
                        )}
                    </div>
                </div>
                <Button onClick={() => onSend(data.id)}>
                    Wyślij formularz
                </Button>
            </div>
            {data.status_message && <div>{data.status_message}</div>}
            <div>Adresaci: {recipients.join(", ")}</div>
            <div>IP: {data.ip}</div>
            {data.ip_whois && (
                <pre>{JSON.stringify(data.ip_whois, null, 2)}</pre>
            )}
            <div
                className="form-response-content"
                dangerouslySetInnerHTML={{ __html: data.body }}
            />
        </FormLayout.Fieldset>
    );
}

ResponseForm.propTypes = {};

ResponseForm.defaultProps = {};

export default ResponseForm;
